
export default function Footer() {
  const quickLinks = [
    { name: 'الرئيسية', href: '/' },
    { name: 'من نحن', href: '/about' },
    { name: 'خدماتنا', href: '/services' },
    { name: 'أعمالنا', href: '/portfolio' },
    { name: 'تواصل معنا', href: '/contact' }
  ];

  const socialLinks = [
    { name: 'فيسبوك', icon: 'ri-facebook-fill', href: '#' },
    { name: 'تويتر', icon: 'ri-twitter-x-fill', href: '#' },
    { name: 'إنستغرام', icon: 'ri-instagram-fill', href: '#' },
    { name: 'لينكد إن', icon: 'ri-linkedin-fill', href: '#' },
    { name: 'يوتيوب', icon: 'ri-youtube-fill', href: '#' }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              K Media Production
            </h3>
            <p className="text-gray-400 mb-6 leading-relaxed">
              شركة إنتاج إعلامي سعودية رائدة تقدم حلولاً إبداعية متكاملة في مجال الإنتاج المرئي والصوتي. 
              نحن نؤمن بقوة الإعلام في تشكيل الواقع ونسعى لتقديم محتوى يعكس رؤيتكم باحتراف عالي.
            </p>
            <div className="flex items-center space-x-4 space-x-reverse">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-yellow-600 transition-all duration-300 transform hover:scale-110"
                  title={social.name}
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-yellow-500">روابط سريعة</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-yellow-500 transition-colors duration-300"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-yellow-500">معلومات التواصل</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3 space-x-reverse">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-fill text-yellow-500"></i>
                </div>
                <span className="text-gray-400">+966 50 123 4567</span>
              </div>
              <div className="flex items-center space-x-3 space-x-reverse">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-fill text-yellow-500"></i>
                </div>
                <span className="text-gray-400">info@kmediaproduction.com</span>
              </div>
              <div className="flex items-start space-x-3 space-x-reverse">
                <div className="w-5 h-5 flex items-center justify-center mt-1">
                  <i className="ri-map-pin-fill text-yellow-500"></i>
                </div>
                <span className="text-gray-400">الرياض، المملكة العربية السعودية</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © 2024 K Media Production. جميع الحقوق محفوظة.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-500 hover:text-yellow-500 text-sm transition-colors duration-300"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
